export const getRootCause = (e: Error) => {
  let cause = e;
  while (cause.cause instanceof Error) {
    cause = cause.cause;
  }

  return cause;
};

export function stringifyError(error: Error) {
  return JSON.stringify(error, [
    'message',
    'cause',
    'stack',
    'type',
    'name',
    'arguments',
  ]);
}

export function stringifyEvent(event: Event) {
  return JSON.stringify(event, eventReplacer);
}

function eventReplacer(key: string, value: any) {
  if (value instanceof Event) {
    const eventObj: Record<string, unknown> = {};
    for (const k in value) {
      eventObj[k] = (value as unknown as Record<string, unknown>)[k];
    }

    return eventObj;
  }

  return value;
}
